import { render, staticRenderFns } from "./IdReverification.vue?vue&type=template&id=208c0961"
import script from "./IdReverification.vue?vue&type=script&lang=js"
export * from "./IdReverification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports